import React, { useState, useEffect, useRef } from "react"

import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { useTranslation } from "react-i18next"

import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { isEmpty, map, size, groupBy, uniqBy, uniq, chain } from "lodash";

import SettingSidebar from "../../components/VerticalLayout/SettingSidebar";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Collapse
} from "reactstrap"
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";

import * as Yup from "yup";
import RsAdNewV2 from "components/buttons/Adnew-v2";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import SaveButton from "components/buttons/save";
import RsLink from "components/buttons/rsLink";
import { get, post, put, del } from "helpers/http_helper";
import Swal from "sweetalert2";
import SafeField from "helpers/SafeField";

const ManageRole = () => {
  const { t } = useTranslation();
  const formikRef = useRef(null);
  
  const [modules, setModules] = useState([]);
  const [openAccordion, setOpenAccordion] = useState(null);
  const [isAddNew, setIsAddNew] = useState(false);
  const [isPermission, setIsPermission] = useState(false);
  const [isManage, setIsManage] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [role, setRole] = useState(null);
  const [userroles, setUserroles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [checkedAccordions, setCheckedAccordions] = useState({});

  useEffect(() => {
    fetchRoles();
  }, []);

  const roleToggle = () => {
    setIsAddNew(prev => !prev);
  };

  const toggleManageRole = () => {
    setIsAddNew(prev => !prev);
  };

  const permissionToggle = () => {
    setIsPermission(prev => !prev);
  };

  const toggleSetPermission = (arg) => {
    if (arg) {
      const roleData = arg;
      setRole({
        id: roleData.id,
      });
      fecthRoleModule(roleData.id);
      permissionToggle();
    } else {
      setRole(null);
      setIsPermission(prev => !prev);
      permissionToggle();
    }
  };

  const toggle = () => {
    setIsManage(prev => !prev);
  };

  const toggleEditRole = (arg) => {
    if (arg) {
      const roleData = arg;
      setRole({
        id: roleData.id,
        userRoleId: roleData.userRoleId,
        userRoleTitle: roleData.userRoleTitle,
        agentId: roleData.agentId,
        isActive: roleData.isActive
      });
      toggle();
    } else {
      setRole(null);
      setIsEdit(false);
      setIsManage(prev => !prev);
      toggle();
    }
  };
  const handleSubmit = (value) => {
    const { userRoleTitle, agentId } = value;
    const payload = {
      userRoleTitle,
      agentId: parseInt(agentId),
      isActive: true,
    };

    toast.loading("Please wait...");

    post('UserRole', payload)
    .then((data) => {
      toast.dismiss();

      if (data.success) {
        toast.success("Saved successfully!");
        fetchRoles();
        toggleManageRole();
      } else {
        toast.error(data?.validationErrors?.[0] || "Submission failed");
        console.warn("Submission failed:", data);
      }
    })
    .catch((error) => {
      toast.dismiss();
      console.error("Error submitting document:", error);
      toast.error("Something went wrong!");
    });
  };

  const fetchRoles = () => {
    const params = {
      agentId: localStorage.getItem('userId')
    };
    get(`UserRole/allAgent`, { params })
      .then((response) => {
        setUserroles(response);
        setLoading(false);
      })
      .catch((error) => {
        setError(error.message);
        setLoading(false);
      });
  };

  const handleDeleteRole = (roleData) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        del(`UserRole/${roleData.id}`)
          .then((response) => {
            Swal.fire("Deleted!", "Delete successfully", "success");
            setUserroles(prev => prev.filter((d) => d.id !== roleData.id));
          })
          .catch((error) => {
            Swal.fire("Error!", "An error occurred while deleting the document.", "error");
          });
      }
    });
  };

  const handleUpdateSubmit = (value) => {
    const { id, userRoleId, userRoleTitle, agentId, isActive } = value;

    const payload = {
      id: Number(id),              
      userRoleId,                 
      userRoleTitle: userRoleTitle?.trim(), 
      agentId: Number(agentId),
      isActive: Boolean(isActive),
    };

    toast.loading("Please wait...");

    put('UserRole', payload)
    .then((data) => {
      toast.dismiss();

      if (data.success) {
        toast.success("Updated successfully!");
        fetchRoles();
        toggleEditRole();
      } else {
        toast.error(data?.validationErrors?.[0] || "Submission failed");
        console.warn("Submission failed:", data);
      }
    })
    .catch((error) => {
      toast.dismiss();
      console.error("Error submitting document:", error);
      //toast.error(error?.response?.data?.message || "Something went wrong!");
    });
  };

  const fecthRoleModule = (roleId) => {
    const params = {
      roleId: 4,
      forRoleId: roleId,
      agentId: localStorage.getItem('userId')
    };
    get(`UserRoleModulePermission/allbyroleidforroleid`, { params })
      .then((response) => {
        setModules(response);
        setLoading(false);
      })
      .catch((error) => {
        setError(error.message);
        setLoading(false);
      });
  };

  const toggleAccordion = (index) => {
    setOpenAccordion(prev => prev === index ? null : index);
  };
   const renderDynamicAccordions = () => {
    if (!modules || modules.length === 0) return null;
    const groupedByType = groupBy(modules, "moduleTypeTitle");

    return Object.entries(groupedByType).map(([typeTitle, moduleItems], typeIdx) => {
    
      const headerPerms = uniq(
        moduleItems.flatMap(m => m.allowedPermissions?.split(",").map(p => p.trim()) || [])
      );

      return (
        <div className="accordion-item" key={typeIdx}>
         
        <div className="d-flex align-items-center w-100">
           <input
            type="checkbox"
            className="me-2"
            onChange={(e) => handleCheckAll(typeIdx, moduleItems, e.target.checked)}
            checked={checkedAccordions?.[typeIdx] || false}
         />
          <button
              className="accordion-button fw-medium"
              type="button"
              onClick={() => toggleAccordion(typeIdx)}
              style={{ cursor: "pointer" }}
            >
              {typeTitle}
            </button>
        </div>
          <Collapse isOpen={openAccordion === typeIdx} className="accordion-collapse">
            <div className="accordion-body">
              <div className="table-responsive">
                <table className="table align-middle table-nowrap mb-0">
                  <thead>
                    <tr>
                      <th></th>
                      {headerPerms.map((perm) => (
                        <th key={perm} className="text-center">{perm}</th>
                      ))}
                    </tr>
                  </thead>

                

                  <tbody>
                  {uniqBy(moduleItems, "moduleTitle").map((module) => {
                    const allowedPerms = module.allowedPermissions
                      ?.split(",")
                      .map((p) => p.trim()) || [];

                    const currentValues = formikRef.current?.values?.[module.moduleTitle] || [];
                    const isRowFullyChecked = allowedPerms.every((perm) => currentValues.includes(perm));

                    return (
                      <tr key={module.moduleId}>
                        

                        <td> <input
                            type="checkbox"
                            checked={isRowFullyChecked}
                            className="me-2"
                            onChange={(e) => {
                              const { setFieldValue } = formikRef.current;
                              setFieldValue(
                                module.moduleTitle,
                                e.target.checked ? allowedPerms : []
                              );
                            }}
                          /> {module.moduleTitle}</td>

                        {allowedPerms.map((perm) => {
                          const permObj = moduleItems.find(
                            (m) => m.moduleId === module.moduleId && m.permTypeTitle === perm
                          );
                          return (
                            <td key={perm} className="text-center">
                              <Field
                                type="checkbox"
                                name={module.moduleTitle}
                                value={perm}
                                defaultChecked={permObj?.isAllowed}
                              />
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
                </table>
              </div>
            </div>
          </Collapse>
        </div>
      );
    });
  };

  const handleCheckAll = (accordionIndex, moduleItems, isChecked) => {
    const formik = formikRef.current;
    if (!formik) return;

    const { setFieldValue } = formik;

    uniqBy(moduleItems, "moduleTitle").forEach((module) => {
      const allowedPerms = module.allowedPermissions?.split(",").map((p) => p.trim()) || [];

      if (isChecked) {
        setFieldValue(module.moduleTitle, allowedPerms); 
      } else {
        setFieldValue(module.moduleTitle, []); 
      }
    });

    // Update accordion-level toggle state (optional)
    setCheckedAccordions(prev => ({
      ...prev,
      [accordionIndex]: isChecked
    }));
  };

  const initialValues = chain(modules)
    .groupBy('moduleTitle')
    .mapValues(list => list
      .filter(item => item.selectedIsAllowed === true)
      .map(item => item.permTypeTitle)
    )
    .value();

  return (
    <React.Fragment>
      <ToastContainer autoClose={2000} />
      <div className="page-content">

     
        <Container fluid>
        
     
         <Row className="">
          <Col xl="12">
           <Breadcrumbs
            title={t("Agent")}
            breadcrumbItem={t("Manage Role")}
          />
         
          </Col>
          <Col sm="12">
           <div className="pt-2 mt-2 d-flex justify-content-center justify-content-xl-end flex-wrap">
                            <RsAdNewV2 to="#" onClick={toggleManageRole} iconClass="bx bx-right-arrow-alt" className="text-purple">
                                Add Role
                            </RsAdNewV2>

                            
            </div>
         
          </Col>
          </Row>
            <Row className="mt-4">
             
              
              <Col xl="12">
              <Formik
                  enableReinitialize={true}
                  initialValues={{
                   
                   

                  }}
                  validationSchema={Yup.object().shape({
                   
                   
                  })}

                  onSubmit={values => {
                  
                   
                  }}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >
            

            
                <Card> 
                    <CardBody>
                    
					<div className="table-responsive">
          <table className="table table-bordered  align-middle table-nowrap mb-0">
              <thead className="">
							  <tr>
								<th>#</th>
								<th>Name</th>
								<th>Permission</th>
                <th>Action</th>
               
                
							  </tr>
							</thead>
                    <tbody>
                              {userroles?.map((roleItem, i) => (
                                    <tr key={i}>
                                        <td>{i+1}</td>
                                        <td>{roleItem.userRoleTitle}</td>
                                        <td><Link to="#" onClick={() => toggleSetPermission(roleItem)}>Permission</Link></td>
                                        <td>
                                           
                                               
                                            <ActionEdit onClick={()=> toggleEditRole(roleItem)} />
                                            <ActionDelete onClick={()=> handleDeleteRole(roleItem)} />
                                            
                                           
                                        </td>
                                    </tr>
                              ))}
                     
                     
                    </tbody>
						  </table>
						</div>
					</CardBody>
					</Card>

                
                


               

            

</Form>
)}
</Formik>


 
            
            </Col>
            
            </Row>
           
          </Container>
        </div>

             <Offcanvas
                        isOpen={isAddNew}
                        direction="end"
                        toggle={toggleManageRole}
                        style={{ width: 500 }}
                      >
                        <OffcanvasHeader toggle={toggleManageRole}>
                          New Role
                        </OffcanvasHeader>
                        <OffcanvasBody>
                           <Formik
                                enableReinitialize={true}
                                initialValues={{
                                
                                   userRoleTitle: "",
                                   agentId : localStorage.getItem('userId')

                                }}
                                validationSchema={Yup.object().shape({
                                       userRoleTitle: Yup.string().required("This Field in required"),
                                
                                })}

                                onSubmit={handleSubmit}
                                >
                                {({ errors, touched, values, handleChange, setFieldValue }) => (
                                    <Form
                                    className="needs-validation"
                                    >
                                     <Row>
                                               <FormGroup className="mb-3">
                                                <Label htmlFor="userRoleTitle">
                                                {t("Role Title *")}
                                                </Label>
                                                <SafeField
                                                name="userRoleTitle"
                                                type="text"
                                                onChange={handleChange}
                                                className={
                                                    "form-control" +
                                                    (errors.userRoleTitle && touched.userRoleTitle
                                                    ? " is-invalid"
                                                    : "")
                                                }
                                                id="userRoleTitle"
                                                />
                                                <ErrorMessage
                                                name="userRoleTitle"
                                                component="div"
                                                className="invalid-feedback"
                                                />
                                            </FormGroup>

                                             <div><SaveButton className="btn btn-primary">{t("Save")}</SaveButton>{ " " }</div>
                                    </Row>           
                                    </Form>
                                )}
                                </Formik>
                        </OffcanvasBody>
                      </Offcanvas>


                          <Offcanvas
                        isOpen={isManage}
                        direction="end"
                        toggle={toggleEditRole}
                        style={{ width: 500 }}
                      >
                        <OffcanvasHeader toggle={toggleEditRole}>
                          Update Role
                        </OffcanvasHeader>
                        <OffcanvasBody>
                           <Formik
                                enableReinitialize={true}
                                initialValues={{
                                    id:role?.id,
                                    userRoleId:role?.userRoleId,
                                    userRoleTitle: role?.userRoleTitle,
                                    agentId : role?.agentId,
                                    isActive: role?.isActive

                                }}
                                validationSchema={Yup.object().shape({
                                       userRoleTitle: Yup.string().required("This Field in required"),
                                
                                })}

                                onSubmit={handleUpdateSubmit}
                                >
                                {({ errors, touched, values, handleChange, setFieldValue }) => (
                                    <Form
                                    className="needs-validation"
                                    >
                                     <Row>
                                               <FormGroup className="mb-3">
                                                <Label htmlFor="userRoleTitle">
                                                {t("Role Title *")}
                                                </Label>
                                                <SafeField
                                                name="userRoleTitle"
                                                type="text"
                                                onChange={handleChange}
                                                className={
                                                    "form-control" +
                                                    (errors.userRoleTitle && touched.userRoleTitle
                                                    ? " is-invalid"
                                                    : "")
                                                }
                                                id="userRoleTitle"
                                                />
                                                <ErrorMessage
                                                name="userRoleTitle"
                                                component="div"
                                                className="invalid-feedback"
                                                />
                                            </FormGroup>

                                             <div><SaveButton className="btn btn-primary">{t("Update")}</SaveButton>{ " " }</div>
                                    </Row>           
                                    </Form>
                                )}
                                </Formik>
                        </OffcanvasBody>
                      </Offcanvas>



                          <Offcanvas
                        isOpen={isPermission}
                        direction="end"
                        toggle={toggleSetPermission}
                        style={{ width: 900 }}
                      >
                        <OffcanvasHeader toggle={toggleSetPermission}>
                          Set Permission
                        </OffcanvasHeader>
                        <OffcanvasBody>
                          <Formik
                                    innerRef={formikRef} 
                                    enableReinitialize={true}
                                    initialValues={initialValues}
                                    validationSchema={Yup.object().shape({


                                    })}

                                    onSubmit={(values) => {
                                            const payload = {
                                              userRoleModulePermissions: modules.map((mod) => {
                                                const selectedPerms = values[mod.moduleTitle] || []; 
                                                const isAllowed = selectedPerms.includes(mod.permTypeTitle);
                                                
                                                return {
                                                  id: mod.selectedUserRoleUserRoleModulePermissionId || 0,
                                                  userRoleModulePermissionId: mod.userRoleModulePermissionId, 
                                                  userRoleModulePermissionTitle: mod.selecteduserRoleModulePermissionTitle,
                                                  userRoleId: role?.id, 
                                                  moduleId: mod.moduleId,
                                                  permissionId: mod.permissionId,
                                                  isAllowed
                                                };
                                              })
                                              
                                            };

                                            toast.loading("Please wait...");

                                            post('UserRoleModulePermission/bulkadd', payload)
                                            .then((data) => {
                                              toast.dismiss();

                                              if (data.success) {
                                                toast.success("Saved successfully!");
                                                fetchRoles();
                                                toggleSetPermission();
                                              } else {
                                                 toast.dismiss();
                                                 toast.success("Saved successfully!");
                                              
                                              }
                                            })
                                            .catch((error) => {
                                              toast.dismiss();
                                              //console.error("Error submitting document:", error);
                                              toast.success("Saved successfully!");
                                            });

                            
                                          }}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >

                                                   <div className="accordion accordion-flush" id="userPermission">
                                                            {renderDynamicAccordions()}
                                                    </div>
                                            
                                            <div style={{marginTop:20}}></div>
                                            <SaveButton>Save</SaveButton>
                                        </Form>
                                    )}
                                </Formik>

                         
                        </OffcanvasBody>
                      </Offcanvas>
      </React.Fragment>
  );
};

ManageRole.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
  match: PropTypes.object,
};

export default ManageRole;
